"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/formfield.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormField = function FormField(_ref) {
  var children = _ref.children,
      className = _ref.className,
      counter = _ref.counter,
      errorMessage = _ref.errorMessage,
      htmlFor = _ref.htmlFor,
      label = _ref.label,
      required = _ref.required,
      tip = _ref.tip,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "className", "counter", "errorMessage", "htmlFor", "label", "required", "tip", "disabled"]);

  var classes = {
    'vn-form-field': true
  };
  var labelClasses = {
    'vn-form-field__label': true,
    'vn-form-field__label--disabled': disabled
  };

  var newChildren = _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      disabled: disabled
    });
  });

  if (className) {
    classes[className] = className;
  }

  var requiredMarkup;

  if (!disabled && required) {
    requiredMarkup = _react.default.createElement("span", {
      className: "vn-form-field__required"
    }, "*");
  }

  var tipMarkup;

  if (tip) {
    tipMarkup = _react.default.createElement("span", {
      className: "vn-form-field__tip"
    }, tip);
  }

  var counterMarkup;

  if (counter >= 0) {
    counterMarkup = _react.default.createElement("span", {
      className: "vn-form-field__counter"
    }, counter);
  }

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(classes)
  }, props), _react.default.createElement("label", {
    className: (0, _classnames.default)(labelClasses),
    htmlFor: htmlFor
  }, label, requiredMarkup, tipMarkup), newChildren, counterMarkup, _react.default.createElement("p", {
    className: "vn-form-field__error-message"
  }, errorMessage));
};

FormField.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  counter: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  htmlFor: _propTypes.default.string,
  label: _propTypes.default.string,
  required: _propTypes.default.bool,
  tip: _propTypes.default.string
};
FormField.defaultProps = {
  className: '',
  counter: undefined,
  disabled: false,
  errorMessage: '',
  htmlFor: undefined,
  label: '',
  required: false,
  tip: null
};
FormField.displayName = 'FormField';
var _default = FormField;
exports.default = _default;